import { NavigationGuardNext, Route } from "vue-router";

import Store from "@/store/index";

function isLogin(): boolean {
  return Store.state.login;
}

function getToken(): string {
  return Store.state.token;
}

// 出勤意思確認（スマホ）専用モードのパス
const INTENTION_PATH = "/attendance-intention";

export default function beforeEach(
  to: Route,
  from: Route,
  next: NavigationGuardNext
): void {
  // 出勤意思確認モード：一度この画面に入った端末（タブ）では、
  // 以降は他画面へ遷移させず出勤意思確認のみ使用できるようにする。
  if (to.path === INTENTION_PATH) {
    sessionStorage.setItem("intentionMode", "1");
  }
  if (sessionStorage.getItem("intentionMode") === "1") {
    if (to.path !== INTENTION_PATH) {
      next(INTENTION_PATH);
      return;
    }
    next();
    return;
  }

  if (!to.matched.some(page => page.meta.public))
    if (!isLogin()) next("/login");

  const path = "/office";
  if (to.path === "/") {
    if (from.path === path) return;
    next(path);
  }
  next();
}
